import type { Environment } from '@change-corgi/config/environments';

import __googleAuth from '../config/googleAuth.json';

export const googleSignInClientIds = __googleAuth.signIn.clientId as Readonly<Record<Environment, string>>;
